import { ApiGroup } from '../types/ApiTypes';

export const PointUseRequestAPI: ApiGroup = {
    pagedList: {
        title: '포인트 사용 요청 목록 조회',
        method: 'POST',
        url: '/PointUseRequest/PagedList',
        paramz: {},
    },
    approve: {
        title: '포인트 사용 요청 승인',
        method: 'POST',
        url: '/PointUseRequest/Approve',
        paramz: {},
    },
    cancel: {
        title: '포인트 사용 요청 취소',
        method: 'POST',
        url: '/PointUseRequest/Cancel',
        paramz: {},
    },
};
